module.exports = __webpack_public_path__ + "img/2.d9422ff7.svg";